"use client";

import { type HTMLAttributes, type Ref, useMemo } from "react";

import cn from "../../utils/cn.util";
import { IconSwapContext } from "./context";
import { rootStyles } from "./styles";

export type IconSwapRootProps = HTMLAttributes<HTMLSpanElement> & {
  /** The `value` of the item to show. */
  value: string;
  ref?: Ref<HTMLSpanElement>;
};

export const Root = ({ value, className, children, ...props }: IconSwapRootProps) => {
  const contextValue = useMemo(() => ({ value }), [value]);

  return (
    <IconSwapContext value={contextValue}>
      <span className={cn(rootStyles(), className)} {...props}>
        {children}
      </span>
    </IconSwapContext>
  );
};

Root.displayName = "IconSwapRoot";
